import { NotificationService } from '@anadolu-commons/tohum-ui';
import { Injectable } from '@angular/core';
import { TranslocoService } from "@ngneat/transloco";

@Injectable({
  providedIn: 'root'
})
export class FuncsService {

  //Notification Modelleri
  BilgilendirmeTitle: string;
  BasariliTitle: string;
  UyariTitle: string;
  HataTitle:string;
  ShowClose: boolean = true;
  TimeOut: number = 15000;
  BilgilendirmeIconClass: string= "fas fa-info";
  BasariliIconClass: string = "fas fa-check";
  UyariIconClass: string = "fa-times-circle";
  HataIconClass: string = "fas fa-exclamation";


  constructor(private translocoService: TranslocoService, private notification:NotificationService) { 

    this.BilgilendirmeTitle = this.translocoService.translate('bilgilendirme');
    this.BasariliTitle = this.translocoService.translate('basarili');
    this.HataTitle = this.translocoService.translate('hata');
    this.UyariTitle = this.translocoService.translate('uyari');
  }

  belgeGenislikHesapla(): number {
    if (window.innerWidth > 1500) {
      return 1000;
    }
    else if (window.innerWidth < 800) {
      return window.innerWidth;
    }
    else {
      return (window.innerWidth * 80) / 100;
    }
  }

  hataMesajiGetir(error: any) {
    if (error === undefined || error === null ||
        error.json === undefined || error.json === null ||
        error.json.detail === undefined || error.json.detail === null ||
        error.json.detail.messages === undefined || error.json.detail.messages === null) {
          return this.translocoService.translate('sistemdeHataOlustu');
    }
    else if (error.json.detail.messages.length === 0) {
      return this.translocoService.translate('sistemdeHataOlustu');
    }
    else {
      return error.json.detail.messages[0].message;
    }
  }

  hataKoduGetir(error: any) {
    if (error === undefined || error === null ||
        error.json === undefined || error.json === null ||
        error.json.detail === undefined || error.json.detail === null ||
        error.json.detail.messages === undefined || error.json.detail.messages === null) {
          return '';
    }
    else if (error.json.detail.messages.length === 0) {
      return '';
    }
    else {
      return error.json.detail.messages[0].id;
    }
  }

  hataMesajiVer(error: any){
    this.notification.error({
      title: this.HataTitle,
      msg: this.hataMesajiGetir(error),
      showClose: this.ShowClose,
      timeout: this.TimeOut,
      iconClass: this.HataIconClass,
    });
  }

  //Error bilgisi backendden gelmeyen, ui tarafında kontrol edilen hatalar için;
  hataMesajiVerUi(errorMesaj: any){
    this.notification.error({
      title: this.HataTitle,
      msg: errorMesaj,
      showClose: this.ShowClose,
      timeout: this.TimeOut,
      iconClass: this.HataIconClass,
    });
  }

  hataMesajiVerUi_baslikIle(baslik:any, errorMesaj: any){
    this.notification.error({
      title: baslik,
      msg: errorMesaj,
      showClose: this.ShowClose,
      timeout: this.TimeOut,
      iconClass: this.HataIconClass,
    });
  }
  basariliMesajiVer(mesaj: any){
    this.notification.success({
      title: this.BasariliTitle,
      msg: mesaj,
      showClose: this.ShowClose,
      timeout: this.TimeOut,
      iconClass: this.BasariliIconClass,
    });
  }
  basariliMesajiVer_baslikIle(title: any, mesaj: any){
    this.notification.success({
      title: title,
      msg: mesaj,
      showClose: this.ShowClose,
      timeout: this.TimeOut,
      iconClass: this.BasariliIconClass,
    });
  }
  bilgilendirmeMesajiVer_baslikIle(title: any, mesaj: any){
    this.notification.info({
      title: title,
      msg: mesaj,
      showClose: this.ShowClose,
      timeout: this.TimeOut,
      iconClass: this.BilgilendirmeIconClass,
    });
  }
  bilgilendirmeMesajiVer(mesaj: any){
    this.notification.info({
      title: this.BilgilendirmeTitle,
      msg: mesaj,
      showClose: this.ShowClose,
      timeout: this.TimeOut,
      iconClass: this.BilgilendirmeIconClass,
    });
  }

  uyariMesajiVer(mesaj){
    this.notification.warning({
      title: this.UyariTitle,
      msg: mesaj,
      showClose: this.ShowClose,
      timeout: this.TimeOut,
      iconClass: this.UyariIconClass,
    });
  }
  uyariMesajiVer_baslikIle(title: any, mesaj: any){
    this.notification.warning({
      title: title,
      msg: mesaj,
      showClose: this.ShowClose,
      timeout: this.TimeOut,
      iconClass: this.UyariIconClass,
    });
  }
}